import React from "react";
import PropTypes from "prop-types";

const VerifyMedicareCardResponse = props => (
  <div>
    {console.log(props.medicareStatus)}
    {props.medicareStatus.status.code === 0
      ? <p className="text-success">Valid Patient Medicare Information</p>
      : <p className="text-danger">Invalid Patient Medicare Information</p>
    }
    {props.medicareStatus.status.text && <p>Description: {props.medicareStatus.status.text}</p>}
    {(props.medicareStatus.currentMembership && props.medicareStatus.currentMembership.memberNumber)
      &&
      <p className="mb-0">Current Medicare Number: {props.medicareStatus.currentMembership.memberNumber}</p>
    }
    {(props.medicareStatus.currentMembership && props.medicareStatus.currentMembership.memberRefNumber)
      &&
      <p className="mb-0">Current Ref. Number: {props.medicareStatus.currentMembership.memberRefNumber}</p>
    }
    {(props.medicareStatus.currentMember && props.medicareStatus.currentMember.givenName)
      && <p className="mb-0">Current Given Name: {props.medicareStatus.currentMember.givenName}</p>}
  </div>
);

export default VerifyMedicareCardResponse;

VerifyMedicareCardResponse.prototype = {
  medicareStatus: PropTypes.object
};
